import { render, staticRenderFns } from "./MemoList.vue?vue&type=template&id=724a4314&scoped=true"
import script from "./MemoList.vue?vue&type=script&lang=ts"
export * from "./MemoList.vue?vue&type=script&lang=ts"
import style0 from "./MemoList.vue?vue&type=style&index=0&id=724a4314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a4314",
  null
  
)

export default component.exports